/** Écran de connexion – portage de design/components/bundle.js (LoginPanel). */
import React from 'react';
import { cx, h, Icon } from './base';
import { TextField } from './formulaires';

export interface LoginPanelProps {
  logo?: React.ReactNode; overline?: string; title: string; subtitle?: string;
  ssoLabel: string; ssoHint?: string; onSso?: () => void; orLabel: string; classicLabel: string; expanded?: boolean;
  emailLabel: string; emailPlaceholder?: string; passwordLabel: string; rememberLabel: string; forgotLabel: string; submitLabel: string;
  onSubmit?: () => void; error?: string; footer?: React.ReactNode;
  /**
   * Ajouts AGORA :
   * - `onToggleClassic` : le dépliant devient contrôlé par l'appelant (`expanded`) ;
   * - `form` : champs du dépliant fournis par l'appelant (étapes e-mail → code), à la place des
   *   champs e-mail / mot de passe de la référence. Le conteneur `form.ag-login-form` (envoi → `onSubmit`) est conservé ;
   * - `ssoBusy` : bouton SSO désactivé pendant la redirection ;
   * - `message` : message (erreur ou information) affiché sous le bouton SSO.
   */
  onToggleClassic?: () => void; form?: React.ReactNode; ssoBusy?: boolean; message?: React.ReactNode;
}

export function LoginPanel(p: LoginPanelProps) {
  const [ouvertInterne, setOuvertInterne] = React.useState(!!p.expanded);
  const open = p.onToggleClassic ? !!p.expanded : ouvertInterne;
  return h('section', { className: cx('ag-login', 'ag-glass', 'ag-glass-strong'), 'aria-label': p.title },
    p.logo ? h('div', { className: 'ag-login-logo' }, p.logo) : null,
    h('div', { className: 'ag-login-head' }, p.overline ? h('div', { className: 'ag-login-over' }, p.overline) : null, h('h1', null, p.title), p.subtitle ? h('p', null, p.subtitle) : null),
    h('button', { type: 'button', className: 'ag-btn ag-btn-primary ag-btn-touch ag-login-sso', onClick: p.onSso, disabled: p.ssoBusy, 'aria-busy': p.ssoBusy || undefined },
      h(Icon, { name: 'key', size: 20 }), p.ssoLabel),
    p.ssoHint ? h('div', { className: 'ag-login-hint' }, p.ssoHint) : null,
    p.message || null,
    h('div', { className: 'ag-login-or' }, h('span', null, p.orLabel)),
    h('button', {
      type: 'button', className: cx('ag-btn', 'ag-btn-secondary', 'ag-btn-touch', 'ag-login-classic'), 'aria-expanded': open,
      onClick: () => (p.onToggleClassic ? p.onToggleClassic() : setOuvertInterne(!open)),
    }, h(Icon, { name: 'mail', size: 20 }), p.classicLabel, h(Icon, { name: 'chevron', size: 16, className: open ? 'ag-rot' : 'ag-rot-closed' })),
    open ? (p.form
      ? h('form', { className: 'ag-login-form', noValidate: true, onSubmit: (e: React.FormEvent) => { e.preventDefault(); p.onSubmit?.(); } }, p.form)
      : h('form', { className: 'ag-login-form', onSubmit: (e: React.FormEvent) => { e.preventDefault(); p.onSubmit?.(); } },
        h(TextField, { label: p.emailLabel, type: 'email', autoComplete: 'username', placeholder: p.emailPlaceholder, inputMode: 'email', error: p.error }),
        h(TextField, { label: p.passwordLabel, type: 'password', autoComplete: 'current-password' }),
        h('div', { className: 'ag-login-row' }, h('label', { className: 'ag-login-remember' }, h('input', { type: 'checkbox' }), p.rememberLabel), h('a', { href: '#', className: 'ag-login-link' }, p.forgotLabel)),
        h('button', { type: 'submit', className: 'ag-btn ag-btn-primary ag-btn-touch' }, p.submitLabel, h(Icon, { name: 'arrow', size: 18 })))) : null,
    h('div', { className: 'ag-login-foot' }, p.footer));
}
